import { render, staticRenderFns } from "./BannerManagement.vue?vue&type=template&id=549c5179&scoped=true"
import script from "./BannerManagement.vue?vue&type=script&lang=js"
export * from "./BannerManagement.vue?vue&type=script&lang=js"
import style0 from "./BannerManagement.vue?vue&type=style&index=0&id=549c5179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c5179",
  null
  
)

export default component.exports